import type { Company, Contact } from "@/components/atomic-crm/types";
import { parseLbsClientContextLinks } from "@/modules/clients/clientContextLinks";
import { normalizeUsPhoneToE164 } from "@/utils/phone";

/** Current saved channels only; historical delivery addresses are not suggestions. */
export const getClientRecipientOptions = (
  mode: "email" | "phone",
  contact?: Contact | null,
  company?: Company | null,
): string[] => {
  const ctx = parseLbsClientContextLinks(company?.context_links);
  const candidates =
    mode === "email"
      ? [
          ...(contact?.email_jsonb ?? []).map((row) => row.email),
          ...(ctx.companyEmails ?? []).map((row) => row.email),
          ctx.businessEmail,
          ...(company?.primary_contact_email_jsonb ?? []).map(
            (row) => row.email,
          ),
          ...(company?.billing_contacts_jsonb ?? []).flatMap((billing) =>
            (billing.email_jsonb ?? []).map((row) => row.email),
          ),
          ctx.invoiceSameAsPrimary === false ? ctx.invoiceEmail : null,
        ]
      : [
          ...(contact?.phone_jsonb ?? []).map((row) => row.number),
          ...(ctx.companyPhones ?? []).map((row) => row.number),
          company?.phone_number,
          ...(company?.primary_contact_phone_jsonb ?? []).map(
            (row) => row.number,
          ),
          ...(company?.billing_contacts_jsonb ?? []).flatMap((billing) =>
            (billing.phone_jsonb ?? []).map((row) => row.number),
          ),
          ctx.invoiceSameAsPrimary === false ? ctx.invoicePhone : null,
        ];
  const values = candidates.map((value) =>
    mode === "email"
      ? (value?.trim().toLowerCase() ?? "")
      : (normalizeUsPhoneToE164(value ?? "") ?? ""),
  );
  return [
    ...new Set(
      values.filter((value) =>
        mode === "email"
          ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          : Boolean(value),
      ),
    ),
  ];
};
